import { LOADER_STATUS, TABLE_DATA, SET_ENTITY_LIST, SET_SELECTED_ENTITY } from "./constants";

export const initialState = {
  loaderStatus: false,
  tableData: [],
  entityList: [],
  selectedEntity: "",
};

/* eslint-disable default-case, no-param-reassign */
const EinvUploadReducerNew = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityList: action.payload,
      };
    case SET_SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.payload,
      };
    default:
      return state;
  }
};

export default EinvUploadReducerNew;
